<template>
    <vx-card :title='(projectList === "waiting") ? $t("InvoicesWaiting") : $t("InvoicesFinished")'>
        <vs-table ref="table" multiple v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="projectsTable">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <vs-button v-if="projectList === 'waiting'" :disabled="selected.length === 0" class="mt-3 mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-check-circle" type="border" id="finishButton" @click='finishProjects'>{{$t("Finish")}}</vs-button>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ projectsTable.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : projectsTable.length }} of {{ projectsTable.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="id">{{$t("Name")}}</vs-th>
                <vs-th></vs-th>
                <vs-th sort-key="company_user">{{$t("User")}}</vs-th>
                <vs-th sort-key="client">{{$t("Client")}}</vs-th>
                <vs-th sort-key="date">{{$t("Date")}}</vs-th>
                <vs-th sort-key="invoice_file">{{$t("File")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td>
                        <vs-button size="small" style="float: left" class="mr-3" color="success" icon-pack="feather" icon="icon-eye" type="border" @click="$router.push({ name: 'project', params: { id: tr.id } })" />
                    </vs-td>

                    <vs-td :data="data[index].company_user">
                        {{ data[index].company_user }}
                    </vs-td>

                    <vs-td :data="data[index].client">
                        {{ data[index].client }}
                    </vs-td>

                    <vs-td :data="data[index].date">
                        {{ moment(data[index].date).format('DD/MM/YYYY HH:mm') }}
                    </vs-td>

                    <vs-td :data="data[index].invoice_file">
                        {{ data[index].invoice_file }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>
    </vx-card>
</template>
<script>

    export default {
        props: {
            projectList: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                selected: [],
                projectsRaw: null,
                itemsPerPage: 20,
                isMounted: false,

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            projectsTable() {

                let list = [];
                if(this.projectsRaw) {
                    for(let x = 0; x < this.projectsRaw.length; x++) {
                        list.push({id:this.projectsRaw[x].id, name:this.projectsRaw[x].name, company_user: this.projectsRaw[x].company_user, client: this.projectsRaw[x].client, date: this.projectsRaw[x].date, invoice_file: this.projectsRaw[x].invoice_file})
                    }
                }

                return list;

            }
        },
        methods: {
            handleSelected(tr) {
                //
            },
            updateProjects() {
                const thisIns = this;
                this.$http.get('/api/v1/project_invoicing/list/' + this.projectList)
                    .then(function (response) {
                        thisIns.projectsRaw = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            finishProjects() {

                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#finishButton",
                    scale: 0.45
                });

                const thisIns = this;

                let list = [];
                for(let x = 0; x < this.selected.length; x++){
                    list.push(Number(this.selected[x].id));
                }

                this.$http.post('/api/v1/project_invoicing/finish', JSON.stringify(list)).then(function () {
                    thisIns.updateProjects();
                    thisIns.selected = [];
                    thisIns.$vs.loading.close("#finishButton > .con-vs-loading");
                }).catch(function (error) {
                    thisIns.$vs.loading.close("#finishButton > .con-vs-loading");
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        watch: {
            projectList: function () {
                this.updateProjects();
            }
        },
        created() {
            this.updateProjects()
        },
        mounted() {
            this.isMounted = true;
        },
    }
</script>
